module.exports = __webpack_public_path__ + "static/media/img_limones-arbol.36db73be.jpg";